// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// const Testimonials = () => {
// const testimonials = [
//   {
//     img: "testi-2-1.jpg",
//     text:
//       "Sanavi Travels provided an excellent experience. The driver was punctual, polite, and the vehicle was very comfortable. Highly recommended for outstation trips.",
//     name: "Mr. Ramesh Kumar",
//     role: "Business Owner, Hyderabad",
//   },
//   {
//     img: "testi-2-2.jpg",
//     text:
//       "We booked a tempo traveller for our family trip and everything was perfectly managed. Clean vehicle, safe driving, and great service.",
//     name: "Ms. Priya Sharma",
//     role: "Homemaker, Bengaluru",
//   },
//   {
//     img: "testi-2-3.jpg",
//     text:
//       "Very professional service. Airport pickup was on time and the ride was smooth. I will definitely book Sanavi Travels again.",
//     name: "Mr. Ankit Verma",
//     role: "IT Professional, Pune",
//   },
//   {
//     img: "testi-2-4.jpg",
//     text:
//       "Affordable pricing and reliable service. The driver was friendly and knew the routes well. Best travel service in the city.",
//     name: "Mr. Suresh Reddy",
//     role: "Entrepreneur, Chennai",
//   },
//   {
//     img: "testi-2-1.jpg",
//     text:
//       "Booked a luxury car for a wedding function. The car arrived on time and looked premium. Guests were very impressed.",
//     name: "Ms. Neha Patel",
//     role: "Event Planner, Ahmedabad",
//   },
//   {
//     img: "testi-2-2.jpg",
//     text:
//       "Sanavi Travels made our temple tour very comfortable. Safe driving and good coordination throughout the journey.",
//     name: "Mr. Venkatesh Rao",
//     role: "Retired Officer, Tirupati",
//   },
// ];


//   return (
//     <section className="testimonials-one section-space" id="testimonial">
//       {/* Background */}
//       <div
//         className="testimonials-one__bg"
//         style={{
//           backgroundImage:
//             "url(/images/backgrounds/testimonials-bg-2-1.png)",
//         }}
//       />

//       <div className="container">
//         <div className="testimonials-one__top">
//           <div className="row align-items-end">
//             <div className="col-lg-8">
//               <div className="sec-title sec-title--two text-start">
//                 <h6 className="sec-title__tagline">
//                   CUSTOMER REVIEWS
//                 </h6>
//                 <h3 className="sec-title__title">
//                   What Our Customers Say <br /> About Sanavi Travels
//                 </h3>
//               </div>
//             </div>
//             <div className="col-lg-4">
//               <div className="testimonials-one__custome-navs" />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Slider */}
//       <div className="testimonials-one__inner">
//         <Swiper
//           modules={[Autoplay, Navigation]}
//           autoplay={{
//             delay: 3000,
//             disableOnInteraction: false,
//           }}
//           navigation={{
//             nextEl: ".icon-arrow-right-2",
//             prevEl: ".icon-arrow-left-2",
//           }}
//           loop={true}
//           spaceBetween={30}
//           breakpoints={{
//             0: { slidesPerView: 1 },
//             992: { slidesPerView: 2 },
//             1400: { slidesPerView: 3 },
//           }}
//           className="rentol-owl__carousel rentol-owl__carousel--with-shadow"
//         >
//           {testimonials.map((item, index) => (
//             <SwiperSlide key={index}>
//               <div className="testimonials-one__item">
//                 <div className="testimonials-card testimonials-card--one">
//                   <div className="testimonials-card__top">
//                     {/* <div className="testimonials-card__image">
//                       <img
//                         src={`/images/resources/${item.img}`}
//                         alt={item.name}
//                       />
//                     </div> */}

//                     {/* Optional Video (can be removed if not needed) */}
//                     <div className="testimonials-card__top__video">
//                       <a
//                         href="#"
//                         className="testimonials-card__video"
//                       >
//                         <i className="icon-play-buttton"></i>
//                       </a>
//                     </div>
//                   </div>

//                   <p className="testimonials-card__text">
//                     “{item.text}”
//                   </p>

//                   <div className="testimonials-card__content">
//                     <div className="testimonials-card__author">
//                       <h4 className="testimonials-card__author__title">
//                         {item.name}
//                       </h4>
//                       <span className="testimonials-card__author__dec">
//                         {item.role}
//                       </span>
//                     </div>

//                     <div className="testimonials-card__rating">
//                       <i className="fa fa-star"></i>
//                       <i className="fa fa-star"></i>
//                       <i className="fa fa-star"></i>
//                       <i className="fa fa-star"></i>
//                       <i className="fa fa-star"></i>
//                     </div>
//                   </div>

//                   <div className="testimonials-card__quite">
//                     <i className="icon-quite"></i>
//                   </div>
//                 </div>
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>

//       {/* Decorative Images */}
//       {/* <div className="testimonials-one__image">
//         <img src="/images/resources/car-2-1.jpg" alt="Sanavi Travels car" />
//       </div> */}

//       {/* <div className="testimonials-one__image__line">
//         <img src="/images/shapes/line-round.png" alt="line" />
//       </div> */}
//     </section>
//   );
// };

// export default Testimonials;


import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const Testimonials = () => {
  const testimonials = [
    {
      text:
        "Sanavi Travels provided an excellent experience. The driver was punctual and the vehicle was very comfortable. Highly recommended for outstation trips.",
      name: "Mr. Ramesh Kumar",
      role: "Business Owner, Hyderabad",
    },
    {
      text:
        "We booked a tempo traveller for our family trip and everything was perfectly managed. Clean vehicle and safe driving.",
      name: "Ms. Priya Sharma",
      role: "Homemaker, Bengaluru",
    },
    {
      text:
        "Very professional service. Airport pickup was on time and the ride was smooth. Will book again.",
      name: "Mr. Ankit Verma",
      role: "IT Professional, Pune",
    },
    {
      text:
        "Affordable pricing and reliable service. The driver was friendly and knew routes well.",
      name: "Mr. Suresh Reddy",
      role: "Entrepreneur, Chennai",
    },
    {
      text:
        "Booked a luxury car for a wedding. The car arrived on time and looked premium.",
      name: "Ms. Neha Patel",
      role: "Event Planner, Ahmedabad",
    },
  ];

  return (
    <section className="testimonials-modern" id="testimonial">
      <div className="container">
        <div className="testimonials-header">
          <span>Customer Reviews</span>
          <h2>What Our Customers Say About Sanavi Travels</h2>
        </div>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
          className="testimonials-swiper"
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <div className="testimonial-top">
                  <div className="avatar">
                    {item.name.charAt(0)}
                  </div>
                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.role}</span>
                  </div>
                </div>

                <p className="testimonial-text">
                  “{item.text}”
                </p>

                <div className="testimonial-rating">
                  ★★★★★
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
